// extracted by css-extract-rspack-plugin
export default {"dialog":"Kroger-module__dialog___XxO3f","container":"Kroger-module__container___o3ZTg","containerMobile":"Kroger-module__containerMobile___qxcDB"};